var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.enrollments,
          columns: _vm.columns_cancellation_reproved,
          "row-key": "id",
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestCancellationReproved
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "full_name", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(props.row.full_name) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "code", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.code) + "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "author", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.author) + "\n\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "created_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.fDate(props.row.created_date)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "attachments",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              round: "",
                              flat: "",
                              icon: "far fa-file-exclamation",
                              color: "secondary",
                              disabled: !props.row.attachments.length
                            },
                            on: {
                              click: function($event) {
                                return _vm.openEvidence(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("show_evidences")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "actions", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "primary",
                              icon: "fal fa-clipboard-list"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "appointment",
                                  params: { id: props.row.presential_event }
                                })
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("training")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "observation", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.observation) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "justification", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.justification) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          model: {
            value: _vm.attachments_view,
            callback: function($$v) {
              _vm.attachments_view = $$v
            },
            expression: "attachments_view"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("evidences")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "q-list",
                {
                  staticClass: "q-mt-md",
                  attrs: { dense: "", bordered: "", padding: "", separator: "" }
                },
                _vm._l(_vm.attachments_to_view, function(attachment, index) {
                  return _c(
                    "q-item",
                    { key: index },
                    [
                      _c("q-item-side", {
                        attrs: { icon: "fal fa-check", color: "positive" }
                      }),
                      _c("q-item-main", [
                        _c(
                          "a",
                          {
                            staticClass: "text-black",
                            attrs: { href: attachment, target: "_blank" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$truncateLink(attachment))
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }